import {getUser} from '@simpleinvest/front-end-auth';
// eslint-disable-next-line import/no-cycle
import store from '@client/store';
import {OverviewRouteNames} from '@client/routes/overview';
import RouteGuard from '@client/util/routeGuard';
// eslint-disable-next-line import/no-cycle
import {LoginRouteNames} from '@client/routes/login';
import {Logger, Category} from '@simpleinvest/front-end-logger';
import {Route, NavigationGuardNext} from 'vue-router';

const logger = new Logger({
  category: Category.Authentication,
  fileName: 'auth.js',
});

const auth = async (to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
  if (to.meta.publicRoute) {
    // eslint-disable-next-line callback-return
    next();
  } else {
    try {
      const user = await getUser();

      store.dispatch('cognitoUser/setUser', user);

      // TODO: See if we can refactor this so this logic runs when the app boots.
      // We shouldn't need to load the segments on every route change.
      if (store.state.settings.isSegmentsSet) {
        next();

        return;
      }

      await store.dispatch('settings/getSegmentSettings');

      // TODO: Replace with individual route checks in each page.
      if (RouteGuard.isRouteValid(to, store.state.settings)) {
        next();

        return;
      }

      // eslint-disable-next-line callback-return
      next({name: OverviewRouteNames.OverviewPage});
    } catch {
      logger.addBreadcrumb({
        callingFuncName: 'auth',
        message: 'Unauthorized, continuing to the Login screen',
      });

      // eslint-disable-next-line callback-return
      next({name: LoginRouteNames.LogoutPage});
    }
  }
};

export default auth;
